var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-wrapper",on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"tooltip"}},[(_vm.isVisible)?_c('div',{class:[
        'custom-tooltip',
        ("custom-tooltip-" + _vm.placement),
        ("custom-tooltip-" + _vm.variant),
        _vm.additionalClass
      ]},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }